module.exports = __webpack_public_path__ + "media/images/emblems/Maracon-coat_of_arms-b7b243db3489b8a02314e4fe968b364e.svg";